@if (department) {
  <a class="department no-drag" [routerLink]="!utils.isDesktop ? departmentUrl : null">
    <div class="department__image">
      <app-image
        [img]="(department.avatar?.previewNormal | addBaseUrl) || '/assets/images/befree.png'"
      ></app-image>
    </div>
    <div class="department__description">
      <a [routerLink]="utils.isDesktop ? departmentUrl : null" class="nav-link">
        @if (department.name) {
          <app-text
            [textSize]="TextSizes.h4Name"
            [textType]="TextType.base"
            [text]="department.name"
          ></app-text>
        }
      </a>
      <app-text
        class="text-grey"
        [textSize]="TextSizes.h3Body"
        [textType]="TextType.base"
        [text]="
          (department.numberOfEmployees ? department.numberOfEmployees : 0)
            | wordDeclension: employeesDeclension
        "
      ></app-text>
    </div>
  </a>
}
